<template>
  <div>
<b-button
  size="sm"
  variant="success"
  :href="`${getBaseURLV2()}/plantation-details/${plot_id._id}?token=${GetLoggedInToken}`"
  target="_blank"
>
  New Assignment
</b-button>
    <b-modal id="modal-1" title="Assignment of  Assets" size="sm">
      <b-alert variant="success" v-if="success" show> {{ success }}</b-alert>
      <b-form @submit.prevent="submitForm">

        <b-form-group id="input-group-2" label="Plantation Assets:" label-for="input-2">
          <b-form-select v-model="form._asset_id" :options="plantationAssets" value-field="_id" text-field="name">
            <template #first>
              <b-form-select-option value="" disabled>Select Plant Asset</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>



        <b-form-group id="input-group-2" label="Quantity:" label-for="input-2">
          <b-form-input v-model="form.qty" placeholder="Enter Quantity"></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="Current Status:" label-for="input-2" v-model="form.status">
          <select v-model="form.status" class="form-control">
            <option value="">Select Status</option>
            <option value="1">Completed</option>
            <option value="0">Pending</option>
          </select>
        </b-form-group>

        <b-form-group id="input-group-2" label="Planned Plantation Date:" label-for="input-2" v-if="form.status == 0">
          <b-form-datepicker id="example-datepicker" v-model="form.planned_plantation_date"
            class="mb-2"></b-form-datepicker>
        </b-form-group>
        <b-form-group id="input-group-2" label="Plantation Date:" label-for="input-2" v-if="form.status == 1">
          <b-form-datepicker id="example-datepicker1" v-model="form.plantation_date" class="mb-2"></b-form-datepicker>
        </b-form-group>
         <b-form-group id="input-group-2" label="Remarks:" label-for="input-2">
          <b-form-textarea v-model="form.remarks" placeholder="Enter Remark"></b-form-textarea>
        </b-form-group>
      </b-form>
      <template #modal-footer="{ ok, close }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" @click="submitForm()">
          Assign
        </b-button>
        <b-button size="sm" variant="danger" @click="close()"> Close </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        _asset_id: "",
        qty: "",
        status: "",
        planned_plantation_date: "",
        plantation_date: "",
        remarks:""
      },
      plantationAssets: [],
      success: false,

    };
  },
  props: ['plot_id'],
  mounted() {
    this.getPlantationAssets();
  },
    computed: {

    GetLoggedInToken(){
      return this.$store.getters.getToken;
    }
  },
  methods: {
        getBaseURLV2() {
      let VUE_APP_NEW_APP_URL = process.env.VUE_APP_APP_URL_V2;
      if (VUE_APP_NEW_APP_URL == "") {
        alert("Please Setup VUE_NEW_APP_URL value in the env")
        process.exit(1);
      }
      return VUE_APP_NEW_APP_URL;
    },
    getPlantationAssets() {
      window.axios.get("assets/category/plantation")
        .then((resp) => {
          this.plantationAssets = resp.data.data;
          console.log("plantationAssets",this.plot_id._id);
          
          console.log(resp);
        });
    },
    submitForm() {
      this.form['plot_id'] = this.plot_id;

      window.axios.post("plot-asset", this.form)
        .then((resp) => {

          console.log(resp);
          if(resp.data.success){
            alert("success");
            this.$bvModal.hide('modal-1')
          }
          this.$emit("modified", resp.data);
        });
    },
  },
};
</script>